import styles from './NewsTicker.module.css';

const SAMPLE_NEWS = [
  'FHWA releases updated work zone data exchange guidance for 2026 compliance',
  'Virginia DOT allocates $2.3B for infrastructure modernization',
  'NHTSA reports 3.2% decrease in work zone fatalities Q1 2026',
  'New IIJA funding tranche: $4.8B for rural bridge replacement',
  'MUTCD 11th Edition adoption deadline: December 2026',
  'SAM.gov reports 47 new transportation solicitations this week',
];

export function NewsTicker() {
  const doubled = [...SAMPLE_NEWS, ...SAMPLE_NEWS];

  return (
    <div className={styles.ticker} role="marquee" aria-label="Live intelligence feed">
      <div className={styles.aiDisclaimer} aria-label="AI assisted disclaimer">
        <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.1" />
          <path d="M6 4.5v2M6 8v.3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
        <span>AI assisted — check all responses for accuracy</span>
      </div>
      <span className={styles.label}>Live</span>
      <div className={styles.track}>
        <div className={styles.content}>
          {doubled.map((item, i) => (
            <span key={i} className={styles.item}>
              <span className={styles.dot} />
              {item}
            </span>
          ))}
        </div>
      </div>
      <div className={styles.flag}>Flag issue</div>
    </div>
  );
}
